import React from "react";
import { useSelector } from "react-redux";
import { authorFilter, categoryFilter } from "../Redux/filters/actionCreator";
import FilterCard from "./FilterCard";

const SelectedFilters = () => {
  const { category, author } = useSelector((state) => state.filters);

  return (
    <div className='mt-12 max-w-lg mx-auto flex gap-6  lg:max-w-none'>
      {category &&
        category.map((singleCategory) => (
          <FilterCard key={singleCategory} filter={singleCategory} filterAction={categoryFilter} />
        ))}
      {author &&
        author.map((singleAuthor) => (
          <FilterCard key={singleAuthor} filter={singleAuthor} filterAction={authorFilter} />
        ))}
    </div>
  );
};

export default SelectedFilters;
